module.exports = __webpack_public_path__ + "static/media/yethi.72c4cc41.png";